import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import izn1776 from '@images/Damat Product/IZN_1776.webp';
import izn1779 from '@images/Damat Product/IZN_1779.webp';
import izn1780 from '@images/Damat Product/IZN_1780.webp';
import izn1807 from '@images/Damat Product/IZN_1807.webp';
import izn1809 from '@images/Damat Product/IZN_1809.webp';
import izn1814 from '@images/Damat Product/IZN_1814.webp';
import izn1819 from '@images/Damat Product/IZN_1819.webp';
import izn1823 from '@images/Damat Product/IZN_1823.webp';
import izn1826 from '@images/Damat Product/IZN_1826.webp';
import izn1858 from '@images/Damat Product/IZN_1858.webp';
import izn1873 from '@images/Damat Product/IZN_1873.webp';
import izn1881 from '@images/Damat Product/IZN_1881.webp';

const HERO_PRODUCT_IMAGES = [
  izn1776,
  izn1779,
  izn1780,
  izn1807,
  izn1809,
  izn1814,
  izn1819,
  izn1823,
  izn1826,
  izn1858,
  izn1873,
  izn1881,
];

const SCHOOL_LIST_MARKDOWN = `# Senarai Alamat Sekolah

> Senarai sekolah mengikut Pejabat Pendidikan Daerah (PPD) di Kedah.

## PPD BALING

| Bil | Kod Sekolah | Nama Sekolah | Alamat | Google Map |
|-----|-------------|--------------|--------|------------|
| 1 | KBA0017 | SEKOLAH KEBANGSAAN KUALA PEGANG | Kuala Pegang,09110 Baling Kedah. | 5.638409849159627, 100.8086190182991 |
| 2 | KBA0023 | SEKOLAH KEBANGSAAN SIONG | Kampong Lalang, Jalan Weng 09100 Baling, Kedah | 5.79442027067059, 100.89673126750529 |
| 3 | KBA0022 | SEKOLAH KEBANGSAAN PULAI | Pulai, 09100 Baling, Kedah | 5.656960872899346, 100.8876221828471 |
| 4 | KBA0032 | SEKOLAH KEBANGSAAN KAMPUNG SELARONG | Kampung Selarong, Malau 09100, Kulim Kedah | 5.53361383471613, 100.69725161353118 |
| 5 | KBA0001 | SEKOLAH KEBANGSAAN MOHD ARIFF ABDULLAH | Kg. Guar Cempedak, 09300 Kuala Ketil, Kedah | 5.636475225781278, 100.67446766750498 |
| 6 | KBA0025 | SEKOLAH KEBANGSAAN TAWAR | Jalan Baling, 09310, Kuala Ketil Kedah | 5.598105425419794, 100.77534466750491 |
| 7 | KBA0026 | SEKOLAH KEBANGSAAN TIAK | 09200 Kupang, Kedah. | 5.578918198727131, 100.87970792517596 |
| 8 | KBB0034 | SEKOLAH KEBANGSAAN TUNKU PUTERA | Jalan pegawai, 09100, Baling Kedah | 5.673754374961838, 100.92268449377254 |
| 9 | KBA0002 | SEKOLAH KEBANGSAAN TELOI KANAN | Felda Teloi Kanan 09300 Kuala Ketil Kedah | 5.716102253089364, 100.66063666750512 |
| 10 | KBA0019 | SEKOLAH KEBANGSAAN KUALA MERAH | Kampung Kuala Merah, 09300 Kuala Ketil Kedah | 5.6065679221628315, 100.70432778284702 |
| 11 | KBA0015 | SEKOLAH KEBANGSAAN KAMPUNG SERA | Kampung Sera, 09100 Baling, Kedah | 5.631748881282109, 100.8972323405182 |

## PPD KOTA SETAR

| Bil | Kod Sekolah | Nama Sekolah | Alamat | Google Map |
|-----|-------------|--------------|--------|------------|
| 1 | KBA2084 | SEKOLAH KEBANGSAAN BUKIT PINANG | Jalan Padang Tembak, 06200 Kepala Batas, Kedah | 6.197829481632018, 100.42988086153022 |
| 2 | KBC2124 | SEKOLAH JENIS KEBANGSAAN (CINA) PUMPONG | Jalan Suka Menanti, 05150, Alor Setar, Kedah | 6.145365828474374, 100.36364537664345 |
| 3 | KBA2095 | SEKOLAH KEBANGSAAN TAMAN BERSATU | Jalan Yan, 06600, Kuala Kedah, Kedah | 6.083610027561316, 100.30333356867519 |
| 4 | KBA2039 | SEKOLAH KEBANGSAAN JALAN PEGAWAI | Persiaran Sultan Abdul Hamid, 05050, Alor Setar, Kedah | 6.103318856395013, 100.36167215830713 |
| 5 | KBB2081 | SEKOLAH KEBANGSAAN ISKANDAR | Jalan Langgar, 05460, Alor Setar, Kedah | 6.1133242561374885, 100.37194395694169 |
| 6 | KBA2016 | SEKOLAH KEBANGSAAN MERGONG | Jalan Putra, 05100, Alor Setar, Kedah | 6.133568892994261, 100.34353513864913 |
| 7 | KBA2042 | SEKOLAH KEBANGSAAN DATO' WAN MOHD SAMAN | Batu 3 Tandop, 05400, Alor Setar, Kedah | 6.074523178257267, 100.36406926704277 |
| 8 | KBA2024 | SEKOLAH KEBANGSAAN ALOR MENGKUDU | Jln. Alor Mengkudu, 05400, Alor Setar, Kedah | 6.088602549531196, 100.39485230060339 |
| 9 | KBA2055 | SEKOLAH KEBANGSAAN KANGKONG | Simpang Empat, 06650, Alor Setar, Kedah | 6.00229754323068, 100.34369052797896 |
| 10 | KBA2014 | SEKOLAH KEBANGSAAN DATO' SHAARI | Kubang Rotan, 06250, Alor Setar, Kedah | 6.139454824774828, 100.30793410686428 |
| 11 | KBAB005 | SEKOLAH KEBANGSAAN JABI | Pokok Sena, 06400, Pokok Sena, Kedah | 6.159513667341712, 100.47580873915668 |
| 12 | KBA2089 | SEKOLAH KEBANGSAAN SERI PANTAI | Kuala Kedah, 06600, Alor Setar, Kedah | 6.098919723774531, 100.28763078755101 |
| 13 | KBA2040 | SEKOLAH KEBANGSAAN SG KOROK LAMA | Persiaran Sultan Abdul Hamid, 05050, Alor Setar, Kedah | 6.108447141720636, 100.36219456283378 |
| 14 | KBAB015 | SEKOLAH KEBANGSAAN BUKIT PAK KIAU | Mukim Gajah Mati, 06400, Pokok Sena, Kedah | 6.159640247001699, 100.53861210092045 |
| 15 | KBA2096 | SEKOLAH KEBANGSAAN HAJI SALLEH MASRI | Km10, Jalan Kuala Kedah, 06600, Alor Setar, Kedah | 6.100433703329871, 100.30257970413565 |
| 16 | KBA2019 | SEKOLAH KEBANGSAAN SUKA MENANTI | Jalan Suka Menanti, 05150, Alor Setar, Kedah | 6.157384167900882, 100.3648320533641 |
| 17 | KBA2093 | SEKOLAH KEBANGSAAN KEBUN PINANG | Tandop, 05400, Alor Setar, Kedah | 6.054603937341284, 100.37683058369336 |
| 18 | KBA2064 | SEKOLAH KEBANGSAAN TEBENGAU | Km 13 , Jalan Yan, 06600, Kuala Kedah, Kedah | 6.046857178468907, 100.33142243103809 |
| 19 | KBA2066 | SEKOLAH KEBANGSAAN DARUL HIKMAH | Km14, Jalan Jelai/Jalan Datuk Kumbar, 06500, Alor Setar, Kedah | 6.050471515875878, 100.43592722108454 |
| 20 | KBA2033 | SEKOLAH KEBANGSAAN HAJI ABU BAKAR | Mukim Lepai, 05350, Alor Setar, Kedah | 6.178075428230563, 100.42092685663292 |
| 21 | KBA2061 | SEKOLAH KEBANGSAAN HJ HASSAN ITAM | Simpang Empat, 06650, Alor Setar, Kedah | 6.021704994129186, 100.3828850603562 |
| 22 | KBA2090 | SEKOLAH KEBANGSAAN SERI PERDANA | Lebuhraya Sultanah Bahiyah, 05350, Alor Setar, Kedah | 6.1392060440063485, 100.34949907301566 |
| 23 | KBAB001 | SEKOLAH KEBANGSAAN WAN ABDUL SAMAD | Pokok Sena, 06400, Pokok Sena, Kedah | 6.169390431896606, 100.51972831085703 |
| 24 | KBA2026 | SEKOLAH KEBANGSAAN HUTAN KAMPONG | Jalan Hutan Kampong, 05350, Alor Setar, Kedah | 6.164730406278113, 100.40268361030205 |
| 25 | KBA2023 | SEKOLAH KEBANGSAAN ALOR MELINTANG | Jalan Datuk Kumbar, 06500, Alor Setar, Kedah | 6.092842780170961, 100.42520050654113 |
| 26 | KBAB002 | SEKOLAH KEBANGSAAN KAMPONG BUKIT | Km.31, Jalan Naka, 06350, Alor Setar, Kedah | 6.141355693685797, 100.61453339815222 |
| 27 | KBA2022 | SEKOLAH KEBANGSAAN KUBANG TEDUH | Gunung Keriang, 06570, Alor Setar, Kedah | 6.206529577545371, 100.3401239985503 |
| 28 | KBA2017 | SEKOLAH KEBANGSAAN PERMATANG GUNUNG | Alor Janggus, 06250, Alor Setar, Kedah | 6.183057398576896, 100.31363349306243 |
| 29 | KBCB002 | SEKOLAH JENIS KEBANGSAAN (CINA) TONG YUH | Pokok Sena, 06400, Pokok Sena, Kedah | 6.168569035423072, 100.51970738657535 |
| 30 | KBB2086 | SEKOLAH KEBANGSAAN CONVENT | Jalan Datuk Kumbar, 05300, Alor Setar, Kedah | 6.126735030985744, 100.3930214501487 |
| 31 | KBA2036 | SEKOLAH KEBANGSAAN SEBERANG PERAK BARU | Jalan Bunga Raya, 05050, Alor Setar, Kedah | 6.111708348390276, 100.35473372420832 |
| 32 | KBA2085 | SEKOLAH KEBANGSAAN TAMAN UDA | Lebuhraya Sultanah Bahiyah, 05350, Alor Setar, Kedah | 6.1460525079692365, 100.38634196069667 |
| 33 | KBB2083 | SEKOLAH KEBANGSAAN TUNKU ABDUL HALIM | Kompleks Pendidikan, Jalan Stadium, 05100, Alor Setar, Kedah | 6.1351790166732005, 100.37582059193095 |
| 34 | KBA2032 | SEKOLAH KEBANGSAAN LANGGAR | Jalan Langgar, 06500, Alor Setar, Kedah | 6.144572457533248, 100.43241692911775 |
| 35 | KBA2025 | SEKOLAH KEBANGSAAN TUNKU RAUDZAH | Jalan Langgar, 05460, Alor Setar, Kedah | 6.121258499146202, 100.38184798503147 |
| 36 | KBA2098 | SEKOLAH KEBANGSAAN TAMAN AWANA | Jalan Langgar, 05460, Alor Setar, Kedah | 6.151928847233308, 100.41257158839599 |
| 37 | KBA2031 | SEKOLAH KEBANGSAAN KUALA KEDAH | Seberang Kota, Kuala Kedah, 06600 Alor Setar, Kedah | 6.112635556819314, 100.2843590561398 |
| 38 | KBA2094 | SEKOLAH KEBANGSAAN TAMAN AMAN | Anak Bukit, 06550, Alor Setar, Kedah | 6.179732376578367, 100.36419460504874 |
| 39 | KBA2012 | SEKOLAH KEBANGSAAN WAN SULAIMAN SIDIQ | Jalan Tambang Badak, 05100, Alor Setar, Kedah | 6.1272395759778675, 100.36569773480893 |
| 40 | KBAB014 | SEKOLAH KEBANGSAAN POKOK SENA | Jalan Kuala Nerang, 06400, Pokok Sena, Kedah | 6.167831445732039, 100.51334824317567 |
| 41 | KBA2037 | SEKOLAH KEBANGSAAN SEBERANG PERAK | Jalan Seberang Perak, 05050, Alor Setar, Kedah | 6.1142894383240876, 100.36127281468609 |
| 42 | KBA2045 | SEKOLAH KEBANGSAAN TELOK KECHAI | Jalan Kuala Kedah, 06600, Alor Setar, Kedah | 6.094717865937083, 100.33130886231424 |

## PPD KUALA MUDA

| Bil | Kod Sekolah | Nama Sekolah | Alamat | Google Map |
|-----|-------------|--------------|--------|------------|
| 1 | KBA3048 | SEKOLAH KEBANGSAAN TAMAN SERI WANG | Sungai Petani ,08000 ,Sungai Petani | 5.620051,100.4974551 |
| 2 | KBD3107 | SEKOLAH JENIS KEBANGSAAN (TAMIL) TAMAN KELADI | Taman Keladi ,08000 ,Sungai Petani | 5.615,100.4291004 |
| 3 | KBA3013 | SEKOLAH KEBANGSAAN HJ. OMAR TAHIR | Pengkalan Bujang ,08100 ,Bedong | 5.6834758,100.3369759 |
| 4 | KBA3029 | SEKOLAH KEBANGSAAN SERI PINANG | Sidam ,08000 ,Sungai Petani | 5.5961959,100.4597533 |
| 5 | KBA3004 | SEKOLAH KEBANGSAAN SERI WANGSA | Bukit Selambau ,08010 ,Sungai Petani | 5.6335109,100.5739014 |
| 6 | KBA3044 | SEKOLAH KEBANGSAAN TAMAN RIA | Jalan Ria 4, Taman Ria ,08000 ,Sungai Petani | 5.6641999,100.4287975 |
| 7 | KBA3056 | SEKOLAH KEBANGSAAN BANDAR PUTERI JAYA | Bandar Puteri Jaya ,08000 ,Sungai Petani | 5.6072171,100.449493 |
| 8 | KBA3030 | SEKOLAH KEBANGSAAN PINANG TUNGGAL | Pinang Tunggal ,08000 ,Sungai Petani | 5.5771375,100.4056029 |
| 9 | KBA3037 | SEKOLAH KEBANGSAAN TIKAM BATU | Tikam Batu ,08600 ,Tikam Batu | 5.5856734,100.3551136 |
| 10 | KBA3055 | SEKOLAH KEBANGSAAN BUKIT KIARA | Jalan Ayam Didik 1, Taman Ria Jaya ,08000 ,Sungai Petani | 5.6426928,100.4381988 |
| 11 | KBD3087 | SEKOLAH JENIS KEBANGSAAN (TAMIL) MAHAJOTHI | Taman Sutera Jaya ,08000 ,Sungai Petani | 5.6257197,100.4415204 |
| 12 | KBA3014 | SEKOLAH KEBANGSAAN PATANI PARA | Ladang Patani Para ,08009 ,Sungai Petani | 5.6869041,100.5044635 |
| 13 | KBC3073 | SEKOLAH JENIS KEBANGSAAN (CINA) TAI TONG | Taman Kempas ,08000 ,Sungai Petani | 5.5941601,100.3966054 |
| 14 | KBA3034 | SEKOLAH KEBANGSAAN SUNGAI PASIR | Kampung Sungai Pasir ,08000 ,Sungai Petani | 5.6154542,100.3799006 |
| 15 | KBC3061 | SEKOLAH JENIS KEBANGSAAN (CINA) CHUNG HWA | Sungailalang ,08100 ,Bedong | 5.701083,100.4336025 |
| 16 | KBA3052 | SEKOLAH KEBANGSAAN SUNGAI PASIR KECHIL | Km 6, Jalan Kuala Ketil, Taman Sutera Jaya ,08000 ,Sungai Petani | 5.6257576,100.4377624 |
| 17 | KBA3054 | SEKOLAH KEBANGSAAN AMBANGAN HEIGHTS | Bandar Baru Sungai Lalang ,08000 ,Sungai Petani | 5.703953,100.4577402 |
| 18 | KBC3069 | SEKOLAH JENIS KEBANGSAAN (CINA) SIN KWANG | Bakar Arang ,08000 ,Sungai Petani | 5.6276819,100.4804653 |
| 19 | KBD3096 | SEKOLAH JENIS KEBANGSAAN (TAMIL) PALANISAMY KUMARAN | Jalan Bahagian Sungai ,08000 ,Sungai Petani | 5.6373593,100.4992472 |
| 20 | KBA3005 | SEKOLAH KEBANGSAAN SULTAN MUDZAFFAR SHAH | Bujang ,08100 ,Bedong | 5.6878391,100.3534158 |
| 21 | KBA3047 | SEKOLAH KEBANGSAAN BANDAR BARU SUNGAI LALANG | Bandar Baru Sungai Lalang ,08000 ,Sungai Petani | 5.7075534,100.4601221 |
| 22 | KBA3032 | SEKOLAH KEBANGSAAN SIDAM KIRI | Padang Serai ,09400 ,Padang Serai | 5.5507166,100.4764544 |
| 23 | KBA3020 | SEKOLAH KEBANGSAAN BUKIT KECHIL | Jalan Pantai Merdeka ,08500 ,Kota Kuala Muda | 5.6510657,100.2743976 |
| 24 | KBA3045 | SEKOLAH KEBANGSAAN SUNGAI LAYAR | Sungai Layar Ujong ,08000 ,Sungai Petani | 5.6669604,100.3903247 |
| 25 | KBA3025 | SEKOLAH KEBANGSAAN KOTA KUALA MUDA | Kota Kuala Muda ,08500 ,Kota Kuala Muda | 5.5871133,100.2911676 |
| 26 | KBC3105 | SEKOLAH JENIS KEBANGSAAN (CINA) LIN KHAY | Bandar Seri Astana ,08000 ,Sungai Petani | 5.5925833,100.434872 |
| 27 | KBA3019 | SEKOLAH KEBANGSAAN TANJONG DAWAI | Tanjong Dawai ,08110 ,Bedong | 5.6848842,100.2805281 |
| 28 | KBA3015 | SEKOLAH KEBANGSAAN SEMELING | Semeling ,08100 ,Bedong | 5.7059847,100.3884051 |
| 29 | KBA3041 | SEKOLAH KEBANGSAAN PETANI JAYA | Taman Petani Jaya ,08000 ,Sungai Petani | 5.6298572,100.408579 |
| 30 | KBA3024 | SEKOLAH KEBANGSAAN SRI GEDONG | Sungai Petani, Kedah ,08000 ,Sungai Petani | 5.6107387,100.4001291 |
| 31 | KBA3050 | SEKOLAH KEBANGSAAN BAKAR ARANG | Taman Arked ,08000 ,Sungai Petani | 5.6284565,100.3891827 |
| 32 | KBA3043 | SEKOLAH KEBANGSAAN TUNKU ISMAIL | Taman Intan ,08000 ,Sungai Petani | 5.6306535,100.3868479 |
| 33 | KBA3036 | SEKOLAH KEBANGSAAN SUNGAI PETANI | Jalan Sekerat ,08000 ,Sungai Petani | 5.6433661,100.413646 |
| 34 | KBA3046 | SEKOLAH KEBANGSAAN KAMPONG PASIR | Kampong Pengkalan Kakap ,08400 ,Merbok | 5.7087455,100.3141369 |
| 35 | KBA3051 | SEKOLAH KEBANGSAAN TAMAN INTAN | Taman Sinar Intan ,08000 ,Sungai Petani | 5.6398098,100.3780991 |

## PPD KUBANG PASU

| Bil | Kod Sekolah | Nama Sekolah | Alamat | Google Map |
|-----|-------------|--------------|--------|------------|
| 1 | KBA4007 | SEKOLAH KEBANGSAAN DATO' WAN KEMARA | - | 6.4276478,100.4264394 |
| 2 | KBA4023 | SEKOLAH KEBANGSAAN BANDAR BUKIT KAYU HITAM | Bandar Bukit Kayu Hitam, 06050 Bukit Kayu Hitam, Kedah | 6.4993138,100.4152929 |
| 3 | KBA4031 | SEKOLAH KEBANGSAAN KEPALA BATAS | Jalan Kg Naga, 06200 Kepala Batas, Kedah | 6.2073517,100.4039224 |
| 4 | KBA4005 | SEKOLAH KEBANGSAAN BINJAL | Asun, 06000 Jitra, Kedah | 6.3363895,100.438535 |
| 5 | KBA4003 | SEKOLAH KEBANGSAAN BATU 8 CHANGLUN | 06010 Changlun, Kedah | 6.4395869,100.2585657 |
| 6 | KBA4057 | SEKOLAH KEBANGSAAN (FELDA) BKT TANGGA | Felda Bukit Tangga, 06050 Bandar Bukit Kayu Hitam, Kedah | 6.4957077,100.4696971 |
| 7 | KBA4059 | SEKOLAH KEBANGSAAN BANDAR BARU SINTOK | Jalan UUM, 06010 Sintok, Kedah | 6.4461335,100.4787275 |
| 8 | KBA4058 | SEKOLAH KEBANGSAAN BUKIT TINGGI | Jalan Bukit Tinggi, 06200 Kepala Batas, Kedah | 6.2056195,100.4242925 |
| 9 | KBC4048 | SEKOLAH JENIS KEBANGSAAN (CINA) YIT MIN | Pekan Baru Jalan Kodiang, 06010 Changlun, Kedah | 6.4330405,100.424712 |
| 10 | KBA4019 | SEKOLAH KEBANGSAAN HAKIM TEH | Pulau Timbul, Mukim Jeram, Tunjang, 06000 Jitra, Kedah | 6.2572722,100.3595449 |
| 11 | KBA4032 | SEKOLAH KEBANGSAAN SERI MUDA | Alor Biak, 06150 Ayer Hitam, Kedah | 6.234635,100.3186352 |
| 12 | KBA4010 | SEKOLAH KEBANGSAAN KODIANG | Jalan Kodiang, 06100 Kodiang, Kedah | 6.391528,100.3061327 |
| 13 | KBA4001 | SEKOLAH KEBANGSAAN AYER HITAM | Jalan Kangar - Alor Setar, Kampung Lubok Ayer, 06150 Ayer Hitam, Kedah | 6.2450895,100.2396549 |
| 14 | KBA4063 | SEKOLAH KEBANGSAAN PUTAT | Telok Tenggiri KM32 Jalan Kodiang, 06000 Jitra, Kedah | 6.3377033,100.3604598 |
| 15 | KBA4034 | SEKOLAH KEBANGSAAN BANDAR BARU DARULAMAN | Bandar Darulaman, 06000 Jitra, Kedah | 6.2407524,100.4253777 |
| 16 | KBA4029 | SEKOLAH KEBANGSAAN MALAU | Jalan Bukit Wang, 06000 Jitra, Kedah | 6.2849065,100.4443744 |
| 17 | KBA4017 | SEKOLAH KEBANGSAAN TUNKU LAKSAMANA | Jalan Pida 6 Tunjang, 06150 Ayer Hitam, Kedah | 6.27108,100.2812948 |
| 18 | KBA4062 | SEKOLAH KEBANGSAAN PADANG PEKAN | Jalan Istana, Kampung Tanjung Kapor, 06000 Jitra, Kedah | 6.2300327,100.3857843 |
| 19 | KBA4064 | SEKOLAH KEBANGSAAN PAYA KEMUNTING | Jalan Changlun, 06000 Jitra, Kedah | 6.2935417, 100.4188200 |
| 20 | KBA4020 | SEKOLAH KEBANGSAAN SANGLANG | Jalan Ayer Hitam, 06150 Ayer Hitam, Kedah | 6.2837332,100.2136948 |
| 21 | KBA4061 | SEKOLAH KEBANGSAAN JITRA 3 | Jalan Hospital, 06000 Jitra, Kedah | 6.2752179,100.3922956 |
| 22 | KBE4023 | SEKOLAH KEBANGSAAN TUNKU BENDAHARA | Jalan Kodiang ke Cganglun, 06100 Kodiang, Kedah | 6.4019518,100.3171722 |
| 23 | KBA4013 | SEKOLAH KEBANGSAAN MEGAT DEWA | Jalan Megat Dewa, 06100 Kodiang, Kedah | 6.3280579,100.3299608 |
| 24 | KBA4009 | SEKOLAH KEBANGSAAN JITRA | Pekan Jitra, 06000 Jitra, Kedah | 6.2620946,100.4169408 |
| 25 | KBA4033 | SEKOLAH KEBANGSAAN JITRA 2 | Jalan Tok Kesop, 06000 Jitra, Kedah | 6.2582553,100.4110038 |
| 26 | KBA4065 | SEKOLAH KEBANGSAAN DARULAMAN HEIGHTS | Bandar Darulaman, 06000 Jitra, Kedah | 6.246667,100.4511497 |

## PPD KULIM BANDAR BAHARU

| Bil | Kod Sekolah | Nama Sekolah | Alamat | Google Map |
|-----|-------------|--------------|--------|------------|
| 1 | KBC5043 | SEKOLAH JENIS KEBANGSAAN (CINA) KELANG LAMA | Jalan Kelang Lama, 09000 Kulim, Kedah | 5.389385, 100.568985 |
| 2 | KBA5018 | SEKOLAH KEBANGSAAN SUNGAI ULAR | SK. Sungai Ular, 09000 Kulim, Kedah | 5.3786797, 100.5771695 |
| 3 | KBA5016 | SEKOLAH KEBANGSAAN SUNGAI KOB | Jalan Kulim - Mahang, Kampung Jangkang, 09700, Karangan, Kedah. | 5.254302, 100.384622 |
| 4 | KBA5015 | SEKOLAH KEBANGSAAN PERMATANG TOK DIK | 09400 Padang Serai, Kedah Darul Aman. | 5.486364127324589, 100.54422521056371 |
| 5 | KBA5020 | SEKOLAH KEBANGSAAN TERAP | 09800 SERDANG, KEDAH DARUL AMAN. | [Pautan](https://maps.app.goo.gl/PhXoTisTdwNzhSAf7?g_st=iw) |
| 6 | KBA5021 | SEKOLAH KEBANGSAAN GUNUNG BONGSU | Felda Gunung Bongsu, 09700 Karangan, Kedah. | 5.3635841, 100.6975111 |
| 7 | KBA5025 | SEKOLAH KEBANGSAAN TAMAN SELASIH | 09000 Kulim,Kedah | [Pautan](https://maps.app.goo.gl/CZhswhKY2X283Vgp8) |
| 8 | KBC5042 | SEKOLAH JENIS KEBANGSAAN (CINA) SHANG CHENG | 09400 PADANG SERAI, KEDAH | [Pautan](https://goo.gl/maps/pGSoaPT2VmxMuuR96?g_st=aw) |
| 9 | KBA5009 | SEKOLAH KEBANGSAAN LABU BESAR | KG.PADANG UBI, 09010 KULIM, KEDAH | [Pautan](https://maps.app.goo.gl/n5FkQ2RZaJ3M1qux9) |
| 10 | KBA5006 | SEKOLAH KEBANGSAAN KELADI | KG. KELADI, 09000, KULIM, KEDAH | 5.3925192,100.5412615 |
| 11 | KBA5003 | SEKOLAH KEBANGSAAN LADANG DUBLIN | 09700 KARANGAN, KEDAH DARUL AMAN | 5.3649° N, 100.7072° E |
| 12 | KBA5019 | SEKOLAH KEBANGSAAN SERI LINDUNGAN RAJA | 09700 KARANGAN, KEDAH DARUL AMAN | 5.410015, 100.735834 |
| 13 | KBA1012 | SEKOLAH KEBANGSAAN SUNGAI KECHIL ULU | 34950 BANDAR BAHARU, KEDAH DARUL AMAN | 100.53809, 5.10814 |
| 14 | KBA5027 | SEKOLAH KEBANGSAAN TAMAN RIA | 09400 PADANG SERAI, KEDAH | 5.5109833  100.5490639 |
| 15 | KBA5026 | SEKOLAH KEBANGSAAN TAMAN KENARI | 09000 KULIM, KEDAH DARUL AMAN | 5.368265,100.571762 |
| 16 | KBA5010 | SEKOLAH KEBANGSAAN SRI LIMAU | Taman Sri Seladang, 09600 Lunas, Kedah | 5.414751468655815, 100.54078546541012 |
| 17 | KBA5008 | SEKOLAH KEBANGSAAN SRI KULIM | Taman Berlian, 09000 Kulim, Kedah | 5.3583510, 100.5463496 |
| 18 | KBA5007 | SEKOLAH KEBANGSAAN KULIM | Jalan Tunku Bendahara, 09000 Kulim, Kedah. | 5.3652839, 100.5575054 |
| 19 | KBA5028 | SEKOLAH KEBANGSAAN JALAN PAYA BESAR | 09600 Lunas, Kedah. | 5.41872, 100.54469 |
| 20 | KBA5024 | SEKOLAH KEBANGSAAN PERMATANG TIONG | Jalan Kampung Air Puteh, Kampung Padang Janggus, 09000 Kulim, Kedah | 5.289640,100.537572 |
| 21 | KBC5037 | SEKOLAH JENIS KEBANGSAAN (CINA) HWA MIN | Jalan Sungai, 09600 Lunas, Kedah. | 5.427865, 100.532027 |

## PPD LANGKAWI

| Bil | Kod Sekolah | Nama Sekolah | Alamat | Google Map |
|-----|-------------|--------------|--------|------------|
| 1 | KBA6008 | SEKOLAH KEBANGSAAN PADANG MATSIRAT | Kampung Bawah, 07000 Langkawi, Kedah | 6.353070375706738, 99.72966660957503 |
| 2 | KBA6023 | SEKOLAH KEBANGSAAN SG MENGHULU | Jalan Batu Asah, 07000 Langkawi,Kedah | 6.335177596768239, 99.8189263524004 |
| 3 | KBA6013 | SEKOLAH KEBANGSAAN LANGKAWI | Jalan Persiaran Putra, Kuah, 07000 Langkawi ,Kedah | 6.3166049926225885, 99.8538626284067 |
| 4 | KBA6012 | SEKOLAH KEBANGSAAN ULU MELAKA | 23, Jalan Ulu Melaka, Kampung Padang Gaong, 07000 Langkawi , Kedah | 6.351598660964676, 99.77510167429814 |
| 5 | KBA6003 | SEKOLAH KEBANGSAAN EWA | Jalan Teluk Yu, Kampung Kelubi, 07000 Langkawi, Kedah | 6.396102305200712, 99.74212738045709 |
| 6 | KBA6002 | SEKOLAH KEBANGSAAN BAYAS | Kampung Bayas, 07000 Langkawi, Kedah | 6.329177456433709, 99.76880171508735 |
| 7 | KBA6011 | SEKOLAH KEBANGSAAN TEMONYONG | 66, Jalan Bohor Tempoyak, Kampung Lubok Buaya, 07000 Langkawi, Kedah | 6.297860275440922, 99.73570998411448 |
| 8 | KBA6010 | SEKOLAH KEBANGSAAN SERI LAGENDA | Jalan Ayer Hangat, Kisap, 07000 Langkawi, Kedah | 6.366148704277623, 99.86625026954967 |
| 9 | KBA6004 | SEKOLAH KEBANGSAAN KEDAWANG | 07000 Langkawi, Kedah | 6.3168116671012555, 99.85425804181084 |
| 10 | KBA6007 | SEKOLAH KEBANGSAAN KUALA TERIANG | Kuala Teriang, 07000 Langkawi, Kedah | 6.361730470346947, 99.71435066559009 |
| 11 | KBA6006 | SEKOLAH KEBANGSAAN SERI NEGERI | Jalan Ayer Hangat, Mukim Kuah, 07000 Langkawi, Kedah | 6.330311092628067, 99.85591214127783 |
| 12 | KBE6001 | SEKOLAH KEBANGSAAN PENGHULU AHMAD | Bohor Merah, 07000 Langkawi, Kedah | 6.423409494988976, 99.8115948699443 |
| 13 | KBA6021 | SEKOLAH KEBANGSAAN NYIOR CHABANG | Kampung Nyior Chabang, Mukim Bohor, 07000 Langkawi, Kedah | 6.3647856058946495, 99.74826178842511 |
| 14 | KBE6005 | SEKOLAH KEBANGSAAN KELIBANG | Jalan Padang Matsirat, Kampung Pokok Asam, 07000 Kuah, Kedah | 6.328822180301713, 99.83654005288443 |

## PPD PADANG TERAP

| Bil | Kod Sekolah | Nama Sekolah | Alamat | Google Map |
|-----|-------------|--------------|--------|------------|
| 1 | KBA7005 | SEKOLAH KEBANGSAAN NAKA | Mukim Tekai Kanan, Naka 06350 Alor Setar Kedah | 6.1375823, 100.6720296 |
| 2 | KBA7015 | SEKOLAH KEBANGSAAN LUBUK MERBAU | Felda Lubuk Merbau, 06710 Pendang, Kedah | 6.001720,100.720461 |

## PPD PENDANG

| Bil | Kod Sekolah | Nama Sekolah | Alamat | Google Map |
|-----|-------------|--------------|--------|------------|
| 1 | KBAA050 | SEKOLAH KEBANGSAAN BKT CHORAS | km 11 Kampung Bukit Choras, Jalan Pendang Kota Sarang Semut, 06800 Pendang, Kedah | 5.970986482139906, 100.41988247922542 |
| 2 | KBAA078 | SEKOLAH KEBANGSAAN SYED IBRAHIM | Kampung Padang Pusing, 06700 Pendang, Kedah | 5.964437489329989, 100.52561039456907 |
| 3 | KBAA057 | SEKOLAH KEBANGSAAN KG CHEGAR | Jln Sungai Tiang, Kampung Pondok Chegar, 06700 Pendang, Kedah | 5.978309303778851, 100.50696485224091 |
| 4 | KBAA161 | SEKOLAH KEBANGSAAN PAYA MAK INSUN | RTP Bukit Mak Insun Pendang, 06720 Pendang, Kedah | 5.890547965657459, 100.53983922155324 |
| 5 | KBAA076 | SEKOLAH KEBANGSAAN POKOK TAI | Kampung Pokok Tai, 06700 Pendang, Kedah | 5.872465854660721, 100.5047071234044 |
| 6 | KBAA046 | SEKOLAH KEBANGSAAN PENGHULU JUSOH | Kampung Kepala Bukit, 06700 Pendang, Kedah | 6.06619488782107, 100.50687543689784 |
| 7 | KBAA054 | SEKOLAH KEBANGSAAN GUAR KEPAYANG | km 24, Mukim Guar Kepayang, 06700 Pendang, Kedah | 6.02828587562162, 100.50980145224122 |
| 8 | KBAA004 | SEKOLAH KEBANGSAAN KUBOR PANJANG | Kubur Panjang, 06400 Pokok Sena, Kedah | 6.088892128453187, 100.55329259456973 |
| 9 | KBAA060 | SEKOLAH KEBANGSAAN KAMPONG BARU | 12, K507, Kampung Baru, 06700 Pendang, Kedah | 5.9649537062703875, 100.57749722340489 |
| 10 | KBAA053 | SEKOLAH KEBANGSAAN CHAROK KUDONG | 06700 Pendang, Kedah | 6.002357084503053, 100.52191976573332 |
| 11 | KBAA059 | SEKOLAH KEBANGSAAN PENDANG | Pendang, 06700 Pendang, Kedah | 5.986344548970664, 100.47708876573324 |
| 12 | KBAA069 | SEKOLAH KEBANGSAAN BUKIT JENUN | Kampung Kilang Besar, 06700 Pendang, Kedah | 5.906597962939042, 100.47713323689688 |

## PPD SIK

| Bil | Kod Sekolah | Nama Sekolah | Alamat | Google Map |
|-----|-------------|--------------|--------|------------|
| 1 | KBA8007 | SEKOLAH KEBANGSAAN HJ HUSSAIN | Kampung Tupai, 08200 Sik, Kedah | 5.822565, 100.679259 |

## PPD YAN

| Bil | Kod Sekolah | Nama Sekolah | Alamat | Google Map |
|-----|-------------|--------------|--------|------------|
| 1 | KBA9021 | SEKOLAH KEBANGSAAN SINGKIR | 08110 Merbok, Kedah | 5.73055, 100.373766 |
| 2 | KBA9022 | SEKOLAH KEBANGSAAN HAJI HUSSIN DOL | 08800 Guar Chempedak, Kedah | 5.857235068698, 100.4643967313 |
| 3 | KBA9018 | SEKOLAH KEBANGSAAN SUNGAI DEDAP | 06800 Kota Sarang Semut, Kedah | 5.937971, 100.364415 |
| 4 | KBA9008 | SEKOLAH KEBANGSAAN KAMPONG PAUH | 06900 Yan, Kedah | 5.805067, 100.391628 |
| 5 | KBA9014 | SEKOLAH KEBANGSAAN HJ NYAK GAM | 06900 Yan, Kedah | 5.800039, 100.373783 |
| 6 | KBA9013 | SEKOLAH KEBANGSAAN YAN KECHIL | 06900 Yan, Kedah | 5.8293556, 100.3860109 |
| 7 | KBA3001 | SEKOLAH KEBANGSAAN GURUN (PUSAT) | 08300 Gurun, Kedah | 5.82213612326175, 100.477450295694 |
| 8 | KBA3002 | SEKOLAH KEBANGSAAN JENIANG (PUSAT) | 08700 Jeniang, Kedah | 5.814066, 100.627583 |
| 9 | KBA3008 | SEKOLAH KEBANGSAAN BEDONG | 08100 Bedong, Kedah | 5.732545, 100.515114 |
| 10 | KBA3038 | SEKOLAH KEBANGSAAN BATU EMPAT | 08300 Gurun,Kedah | 5.81698876723341, 100.525291077297 |`;

const extractMapUrl = (mapCell) => {
  if (!mapCell) return null;
  const mdLinkMatch = mapCell.match(/\((https?:\/\/[^)]+)\)/i);
  if (mdLinkMatch?.[1]) return mdLinkMatch[1];
  if (/(https?:\/\/\S+)/i.test(mapCell)) return mapCell.match(/(https?:\/\/\S+)/i)?.[1] ?? null;
  return null;
};

const extractLatLng = (mapCell) => {
  if (!mapCell) return { lat: null, lng: null };
  const nums = mapCell.match(/-?\d+(?:\.\d+)?/g);
  if (!nums || nums.length < 2) return { lat: null, lng: null };

  const a = Number(nums[0]);
  const b = Number(nums[1]);
  if (Number.isNaN(a) || Number.isNaN(b)) return { lat: null, lng: null };

  let lat = a;
  let lng = b;
  if (Math.abs(lat) > 90 && Math.abs(lng) <= 90) {
    lat = b;
    lng = a;
  }
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return { lat: null, lng: null };

  return { lat, lng };
};

const buildGoogleMapsUrl = ({ mapCell }) => {
  const directUrl = extractMapUrl(mapCell);
  if (directUrl) return directUrl;

  const { lat, lng } = extractLatLng(mapCell);
  if (lat == null || lng == null) return null;

  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${lat},${lng}`)}`;
};

const parseSchoolsFromMarkdown = (markdown) => {
  const lines = markdown.split(/\r?\n/);
  let currentPpd = '';
  const items = [];

  for (const line of lines) {
    if (line.startsWith('## ')) {
      const title = line.replace(/^##\s+/, '').trim();
      currentPpd = title.toUpperCase().startsWith('PPD ') ? title.slice(4).trim() : title;
      continue;
    }

    if (!line.startsWith('|')) continue;
    if (line.includes('|-----|')) continue;

    const cells = line.split('|').slice(1, -1).map((c) => c.trim());
    if (!cells.length) continue;
    if (cells[0] === 'Bil') continue;

    const bil = cells[0] ?? '';
    const code = cells[1] ?? '';
    const name = cells[2] ?? '';
    const address = cells[3] ?? '';
    const mapCell = cells[4] ?? '';

    if (!code || !name) continue;

    const { lat, lng } = extractLatLng(mapCell);
    const mapUrl = buildGoogleMapsUrl({ mapCell });

    items.push({
      id: `${currentPpd}:${code}`,
      ppd: currentPpd || 'Unknown',
      bil,
      code,
      name,
      address,
      lat,
      lng,
      mapUrl
    });
  }

  return items;
};

const Home = () => {
  const schools = useMemo(() => parseSchoolsFromMarkdown(SCHOOL_LIST_MARKDOWN), []);
  const [stats, setStats] = useState({
    totalGames: 0,
    totalStudents: 0,
    totalSchools: 0
  });
  const [schoolSearch, setSchoolSearch] = useState('');
  const [schoolPpd, setSchoolPpd] = useState('All');
  const [heroSlideIndex, setHeroSlideIndex] = useState(0);

  useEffect(() => {
    // Simulate some basic stats for now
    setStats({
      totalGames: 1250,
      totalStudents: 3500,
      totalSchools: schools.length
    });
  }, [schools.length]);

  useEffect(() => {
    if (HERO_PRODUCT_IMAGES.length <= 1) return;
    const intervalMs = 3500;
    const id = window.setInterval(() => {
      setHeroSlideIndex((prev) => (prev + 1) % HERO_PRODUCT_IMAGES.length);
    }, intervalMs);
    return () => window.clearInterval(id);
  }, []);

  const ppdOptions = useMemo(() => {
    const ppds = Array.from(new Set(schools.map((s) => s.ppd))).filter(Boolean);
    ppds.sort((a, b) => a.localeCompare(b));
    return ['All', ...ppds];
  }, [schools]);

  const filteredSchools = useMemo(() => {
    const q = schoolSearch.trim().toLowerCase();
    return schools.filter((s) => {
      if (schoolPpd !== 'All' && s.ppd !== schoolPpd) return false;
      if (!q) return true;
      return (
        s.code.toLowerCase().includes(q) ||
        s.name.toLowerCase().includes(q) ||
        s.address.toLowerCase().includes(q) ||
        s.ppd.toLowerCase().includes(q)
      );
    });
  }, [schoolPpd, schoolSearch, schools]);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 via-white to-yellow-50 py-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-10 text-6xl text-yellow-300 opacity-20 animate-bounce">+</div>
          <div className="absolute top-40 right-20 text-5xl text-blue-300 opacity-20 animate-pulse">×</div>
          <div className="absolute bottom-20 left-20 text-4xl text-red-300 opacity-20 animate-bounce">÷</div>
          <div className="absolute bottom-40 right-10 text-6xl text-green-300 opacity-20 animate-pulse">−</div>
          <div className="absolute top-1/3 left-1/3 text-3xl text-purple-300 opacity-20">123</div>
          <div className="absolute top-2/3 right-1/3 text-4xl text-orange-300 opacity-20">🎲</div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-800 mb-6">
                🎲 Turn Learning Into a{' '}
                <span className="text-red-600 bg-yellow-100 px-4 py-2 rounded-xl inline-block transform rotate-1">
                  Game
                </span>{' '}
                with DAMAT!
              </h1>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                Malaysia's first arithmetic board game developed by a local university — 
                built to make math fun for kids aged 6 to 12.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/try-demo"
                  className="bg-gradient-to-r from-red-500 to-red-600 text-white px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center justify-center"
                >
                  🎮 Try a Demo Game
                </Link>
                <Link
                  to="/products"
                  className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-800 px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center justify-center"
                >
                  🛍️ Explore Products
                </Link>
                <Link
                  to="/educators"
                  className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center justify-center"  
                >
                  🏫 For Educators
                </Link>
              </div>
            </div>
            <div className="flex justify-center">
              <div className="w-full max-w-xl transform hover:scale-105 transition-transform duration-300">
                <div className="rounded-2xl shadow-2xl overflow-hidden bg-white/70">
                  <div
                    className="flex h-[420px] transition-transform duration-700 ease-in-out"
                    style={{ transform: `translateX(-${heroSlideIndex * 100}%)` }}
                  >
                    {HERO_PRODUCT_IMAGES.map((src, idx) => (
                      <div key={src} className="w-full h-full flex-shrink-0 flex items-center justify-center p-4">
                        <img
                          src={src}
                          alt={`DAMAT product ${idx + 1}`}
                          className="w-full h-full object-contain"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What is DAMAT Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">What is DAMAT?</h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              DAMAT is a hands-on math game designed to build arithmetic skills through fun, dice-based gameplay. 
              Backed by educational research, DAMAT helps children master addition, subtraction, multiplication, 
              and division — while having a blast.
            </p>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-20 bg-gradient-to-r from-blue-50 to-purple-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">How It Works</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-gradient-to-br from-red-400 to-red-600 text-white p-8 rounded-2xl shadow-lg mb-6 transform hover:scale-105 transition-transform">
                <span className="text-6xl">🎲</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">1. Roll the Dice</h3>
              <p className="text-gray-600">Start your math adventure by rolling the dice to get your numbers!</p>
            </div>
            <div className="text-center">
              <div className="bg-gradient-to-br from-yellow-400 to-yellow-600 text-white p-8 rounded-2xl shadow-lg mb-6 transform hover:scale-105 transition-transform">
                <span className="text-6xl">➕</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">2. Solve the Operation</h3>
              <p className="text-gray-600">Use addition, subtraction, multiplication, or division to solve the math problem!</p>
            </div>
            <div className="text-center">
              <div className="bg-gradient-to-br from-green-400 to-green-600 text-white p-8 rounded-2xl shadow-lg mb-6 transform hover:scale-105 transition-transform">
                <span className="text-6xl">🏁</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">3. Reach the Goal First!</h3>
              <p className="text-gray-600">Be the first to reach the finish line and win the game!</p>
            </div>
          </div>
        </div>
      </section>

      {/* Products Preview Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Explore Our Products</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-yellow-100 to-yellow-200 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="text-4xl mb-4">📋</div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">A2 Set</h3>
              <p className="text-gray-600 mb-6">Perfect for home or tuition centers. Compact and easy to use!</p>
              <div className="bg-yellow-200 px-4 py-2 rounded-lg text-sm font-medium text-yellow-800 inline-block">
                Ages 6-12
              </div>
            </div>
            <div className="bg-gradient-to-br from-green-100 to-green-200 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="text-4xl mb-4">🏫</div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Classroom Carpet Set</h3>
              <p className="text-gray-600 mb-6">Built for school groups & math corners. Interactive floor play!</p>
              <div className="bg-green-200 px-4 py-2 rounded-lg text-sm font-medium text-green-800 inline-block">
                Up to 6 players
              </div>
            </div>
            <div className="bg-gradient-to-br from-blue-100 to-blue-200 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="text-4xl mb-4">💻</div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Digital Edition</h3>
              <p className="text-gray-600 mb-6">On-the-go learning fun for modern families!</p>
              <div className="bg-blue-200 px-4 py-2 rounded-lg text-sm font-medium text-blue-800 inline-block">
                Coming Soon
              </div>
            </div>
          </div>
          <div className="text-center mt-12">
            <Link
              to="/products"
              className="bg-gradient-to-r from-red-500 to-red-600 text-white px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 inline-flex items-center"
            >
              View All Products →
            </Link>
          </div>
        </div>
      </section>

      {/* Why Parents & Teachers Love DAMAT */}
      <section className="py-20 bg-gradient-to-br from-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">Why Parents & Teachers Love DAMAT</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6">
              <div className="bg-gradient-to-br from-yellow-400 to-yellow-500 text-white p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">💡</span>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Encourages Mental Math</h3>
              <p className="text-gray-600">Builds quick calculation skills through repeated practice</p>
            </div>
            <div className="text-center p-6">
              <div className="bg-gradient-to-br from-blue-400 to-blue-500 text-white p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🤝</span>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Promotes Group Learning</h3>
              <p className="text-gray-600">Social interaction enhances the learning experience</p>
            </div>
            <div className="text-center p-6">
              <div className="bg-gradient-to-br from-green-400 to-green-500 text-white p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🎯</span>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Aligns with School Curriculum</h3>
              <p className="text-gray-600">Supports KSSR math objectives for Malaysian schools</p>
            </div>
            <div className="text-center p-6">
              <div className="bg-gradient-to-br from-red-400 to-red-500 text-white p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">✅</span>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Child-Safe & Parent-Approved</h3>
              <p className="text-gray-600">Developed by education experts with safety in mind</p>
            </div>
          </div>
        </div>
      </section>

      {/* Live Stats Section */}
      <section className="py-20 bg-gray-800 text-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-16">DAMAT Impact Across Malaysia</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-5xl font-bold text-yellow-400 mb-2">{stats.totalGames.toLocaleString()}+</div>
              <p className="text-xl text-gray-300">Games Played</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-blue-400 mb-2">{stats.totalStudents.toLocaleString()}+</div>
              <p className="text-xl text-gray-300">Students Engaged</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-green-400 mb-2">{stats.totalSchools}+</div>
              <p className="text-xl text-gray-300">Schools Reached</p>
            </div>
          </div>
          <div className="text-center mt-12">
            <Link
              to="/game-scoreboard"
              className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-gray-800 px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 inline-flex items-center"
            >
              View Live Scoreboard →
            </Link>
          </div>

          <div className="mt-16 bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8">
            <div className="flex flex-col lg:flex-row gap-4 lg:items-end">
              <div className="flex-1">
                <label htmlFor="school-search" className="block text-sm font-semibold text-gray-200 mb-2">
                  Search schools
                </label>
                <input
                  id="school-search"
                  type="text"
                  value={schoolSearch}
                  onChange={(e) => setSchoolSearch(e.target.value)}
                  placeholder="Search by school name, code, address, or PPD…"
                  className="w-full rounded-xl bg-white/10 border border-white/10 px-4 py-3 text-white placeholder:text-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-400/60"
                />
              </div>

              <div className="w-full lg:w-72">
                <label htmlFor="school-ppd" className="block text-sm font-semibold text-gray-200 mb-2">
                  PPD
                </label>
                <select
                  id="school-ppd"
                  value={schoolPpd}
                  onChange={(e) => setSchoolPpd(e.target.value)}
                  className="w-full rounded-xl bg-white/10 border border-white/10 px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-yellow-400/60"
                >
                  {ppdOptions.map((ppd) => (
                    <option key={ppd} value={ppd} className="text-gray-900">
                      {ppd}
                    </option>
                  ))}
                </select>
              </div>

              <button
                type="button"
                onClick={() => {
                  setSchoolSearch('');
                  setSchoolPpd('All');
                }}
                disabled={!schoolSearch && schoolPpd === 'All'}
                className="w-full lg:w-auto rounded-xl bg-white/10 border border-white/10 px-5 py-3 font-semibold text-gray-100 hover:bg-white/15 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Clear
              </button>
            </div>

            <div className="mt-4 text-sm text-gray-300">
              Showing <span className="font-semibold text-white">{filteredSchools.length}</span> of{' '}
              <span className="font-semibold text-white">{schools.length}</span> schools
            </div>

            <div className="mt-6 overflow-x-auto rounded-xl border border-white/10">
              <table className="min-w-full text-sm">
                <thead className="bg-white/10 text-gray-200">
                  <tr>
                    <th scope="col" className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                      Code
                    </th>
                    <th scope="col" className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                      School
                    </th>
                    <th scope="col" className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                      Address
                    </th>
                    <th scope="col" className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                      PPD
                    </th>
                    <th scope="col" className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                      Map
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-white/10">
                  {filteredSchools.map((s) => (
                    <tr key={s.id} className="hover:bg-white/5">
                      <td className="px-4 py-3 whitespace-nowrap text-gray-100">{s.code}</td>
                      <td className="px-4 py-3 text-gray-100">{s.name}</td>
                      <td className="px-4 py-3 text-gray-300 min-w-[260px]">{s.address}</td>
                      <td className="px-4 py-3 whitespace-nowrap text-gray-300">{s.ppd}</td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        {s.mapUrl ? (
                          <a
                            href={s.mapUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center rounded-lg bg-yellow-500/20 border border-yellow-400/30 px-3 py-1.5 font-semibold text-yellow-200 hover:bg-yellow-500/30"
                          >
                            Open
                          </a>
                        ) : (
                          <span className="text-gray-400">—</span>
                        )}
                      </td>
                    </tr>
                  ))}
                  {!filteredSchools.length ? (
                    <tr>
                      <td colSpan={5} className="px-4 py-10 text-center text-gray-300">
                        No schools match your filters.
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Try DAMAT Now Section */}
      <section className="py-20 bg-gradient-to-r from-green-400 to-blue-500 text-white">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Try DAMAT Now!</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Want to see how it works? Try our quick demo game online and experience the fun of learning math!
          </p>
          <Link
            to="/try-demo"
            className="bg-white text-green-600 px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 inline-flex items-center"
          >
            🎮 Play Demo →
          </Link>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">Trusted by Schools Across Malaysia</h2>
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-2xl shadow-lg text-center">
              <div className="text-6xl mb-4">⭐⭐⭐⭐⭐</div>
              <blockquote className="text-2xl font-medium text-gray-800 mb-6 italic">
                "My students enjoy math time for the first time ever! DAMAT has transformed how we approach 
                arithmetic in our classroom. The kids are excited to learn and practice math skills."
              </blockquote>
              <p className="text-lg text-gray-600">
                <strong>Teacher Fatin</strong> - Primary School, Perlis
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 bg-gradient-to-r from-red-500 to-purple-600 text-white">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to bring DAMAT into your home or classroom?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join thousands of families and educators who are making math fun with DAMAT!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/products"
              className="bg-white text-red-600 px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 inline-flex items-center justify-center"
            >
              📦 Pre-Order Now
            </Link>
            <Link
              to="/contact"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-white hover:text-red-600 transition-all duration-200 inline-flex items-center justify-center"
            >
              📨 Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
